import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { DynamicFormField } from '../../DynamicFormField';

export const subjectMathematicsConfig: Record<string, FormConfigProps> = {
  usedVisualAid: {
    label:
      'naudojamos vaizdinės priemonės / fiziniai objektai,  iliustruojantys sąvokas / procesus',
    value: 'usedVisualAid',
  },
  altSolutionsTaught: {
    label:
      'mokoma atlikti tą pačią užduotį keliais būdais, pasirinkti tinkamas veiklos strategijas',
    value: 'altSolutionsTaught',
  },
  oneWaySolution: {
    label: 'mokoma atlikti užduotį vienu būdu',
    value: 'oneWaySolution',
  },
  referencesToStepsAndSequence: {
    label:
      'pateikiamos nuorodos apie uždavinio sprendimo veiksmus ir jų eiliškumą',
    value: 'referencesToStepsAndSequence',
  },
  tasksForStuctureOfNumbers: {
    label: 'pateikiamos užduotys, kuriose aiškiai išdėstoma skaičių struktūra',
    value: 'tasksForStuctureOfNumbers',
  },
};

export const SubjectMathematics = ({ form }: CompWithFormProp) => {
  return (
    <DynamicFormField
      formItemConfig={subjectMathematicsConfig}
      formPathParams={['subject', 'block3', 'methods']}
      form={form}
    />
  );
};
